import useAuth from 'client/utils/auth/useAuth';
import { useEffect } from 'react';
import Workspace from 'client/pages/HomePage/Workspace/Workspace';
import Markdown from 'client/components/aria/MarkDown/Markdown';
import ErrorMessage from 'client/utils/routes/ErrorMessage/ErrorMessage';
import { useLocaleAutoSwitch } from 'i18n/localeUtils';
import { useDispatch } from 'react-redux';
import { fetchSystemNoticesOnce } from 'client/store/systemMessageSlice/systemMessageSlice';

const SignedInHomePage = ({ acceptableUsage = null }) => {
    const { isAuthenticated } = useAuth();
    const dispatch = useDispatch();
    useLocaleAutoSwitch();

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchSystemNoticesOnce());
        }
    }, [dispatch, isAuthenticated]);

    return (
        <div className="homePageSignedIn" data-testid="homePageSignedIn">
            <hr className="govuk-section-break govuk-section-break--l govuk-section-break--visible" />
            <Workspace/>
            { isAuthenticated && acceptableUsage?.markdown != null && acceptableUsage?.markdown.length > 0
                ? (<Markdown data-testid='acceptableUsage'>
                    {acceptableUsage?.markdown}</Markdown>
                )
                : isAuthenticated
                    ? (<ErrorMessage code={500}/>
                    )
                    : null
            }
        </div>
    );
};

export default SignedInHomePage;
